import { useEffect, useState } from "react";

const links = [
  { href: "#hot", label: "最新热瓜" },
  { href: "#reverse", label: "反转时间线" },
  { href: "#rank", label: "热榜追踪" },
  { href: "#deny", label: "辟谣专区" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            扒哥<span className="text-primary-600">吃瓜</span>前线
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-notification-3-line"></i>
            订阅追更
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 lg:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4 md:px-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-200/70"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50"
            >
              <i className="ri-notification-3-line"></i>
              订阅追更
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}